package org.braunequip.web.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.braunequip.web.components.bulma.PhotoGallery
import org.braunequip.web.components.layouts.PageLayout
import org.braunequip.web.styles.*
import org.braunequip.web.util.Constants
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

val truckingListImages = listOf(
    "trucking/dust tornado with dozer.jpg",
    "trucking/image1 (5).jpeg",
    "trucking/image2.jpeg",
    "trucking/image2 (1).jpeg",
    "trucking/image3 (2).jpeg",
    "trucking/image3 (3).jpeg",
    "trucking/image4 (2).jpeg",
    "trucking/image4 (4).jpeg",
    "trucking/image5-0001.jpeg",
    "trucking/image6.jpeg",
    "trucking/image8.jpeg",
    "trucking/image9.jpeg",
    "trucking/image10.jpeg",
    "trucking/image11.jpeg",
    "trucking/image13 (1).jpeg",
    "trucking/image14.jpeg",
    "trucking/IMG_0427.jpg",
    "trucking/IMG_0810.jpg",
    "trucking/IMG_2523.jpg",
    "trucking/IMG_3489.jpg",
    "trucking/IMG_4400.jpg",
    "trucking/IMG_4416.jpg",
    "trucking/IMG_4417.jpg",
    "trucking/IMG_4426.jpg",
    "trucking/Resized_20230818_125012.JPEG",
    "trucking/Resized_20231020_101658.JPEG"
)

@Page
@Composable
fun TruckingPage() {
    val scope = rememberCoroutineScope()
    val truckingGallery = remember { PhotoGallery(
        id = "trucking",
        imgUrls = truckingListImages
    ) }


    PageLayout("Trucking") {
        //Modals:
        truckingGallery.DisplayGallery()

        //Hero Section
        Section(PageHeroContainer.toModifier().then(truckingHeroBg.toModifier()).toAttrs()) {
            Row(PageHeroSectionRow.toModifier(), horizontalArrangement = Arrangement.Start) {
                Div(PageHeroHeadlineStyle.toModifier().toAttrs()) {
                    SpanText("Flatbed Trucking")
                }
            }
        }

        Section(
            SectionContainer
                .toModifier()
                .backgroundColor(Colors.Black)
                .toAttrs()
        ) {
            Div(Modifier.classNames("container", "is-max-desktop").toAttrs()) {
                Row(
                    SectionTitleRow.toModifier(),
                    horizontalArrangement = Arrangement.Start
                ) {
                    Div(
                        HeadlineTextStyle
                            .toModifier()
                            .color(Colors.White)
                            .toAttrs()
                    ) {
                        SpanText("Trucking Services")
                    }
                }

                Row(
                    SectionSubtitleRow.toModifier()
                ) {
                    P(
                        Modifier
                            .margin(0.px)
                            .fontFamily(Constants.FONT_FAMILY2)
                            .toAttrs()
                    ) {
                        Text("Braun Equipment, a leading transportation company, is distinguished by our unwavering commitment to superior service. Specializing in a wide range of shipping solutions, including flatbed, bottom dump, end dump, tanker, log hauling, and chip hauling, our versatility ensures we meet diverse customer needs. At Braun Equipment, our focus on safety, efficiency, and building lasting relationships sets us apart in the industry. ")
                    }
                }

                Row(Modifier) {
                    Div(servicesContainer.toModifier().toAttrs()) {
                        Div(servicesBlock.toAttrs()) {
                            SpanText("Log Hauling")
                            SpanText("Chip Hauling")
                        }

                        Div(servicesBlock.toAttrs()) {
                            SpanText("Flatbed")
                            SpanText("Lawbed")
                        }

                        Div(servicesBlock.toAttrs()) {
                            SpanText("Bottom Dump")
                            SpanText("End Dump")
                        }

                        Div(servicesBlock.toAttrs()) {
                            SpanText("Water Trucks")
                            SpanText("Dry Van")
                        }
                    }
                }

                Row(
                    Modifier
                        .fontFamily(Constants.FONT_FAMILY2)
                        .fontSize(18.px)
                        .gap(1.3.cssRem).padding(topBottom = 2.cssRem)
                        .color(Colors.LightGray),
                    horizontalArrangement = Arrangement.Center
                ) {

                    SpanText("MC # 947831", Modifier.fontWeight(FontWeight.Light))
                    SpanText(" | ", Modifier)
                    SpanText("US DOT # 2834001", Modifier.fontWeight(FontWeight.Light))
                }
            }
        }

        Section(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("section", "is-small", "has-background-light").toAttrs()) {
            Div(Modifier.classNames("container", "is-max-desktop").toAttrs()) {

                H1(Modifier.classNames("title", "has-text-black", "has-text-centered").toAttrs()) { Text("RECENT PROJECTS") }

                Div(Modifier.classNames("columns", "is-centered").toAttrs()) {

                    val previewImages = truckingGallery.getExternalImages(3)
                    console.log(previewImages.size)
                    previewImages.forEach { galleryImg ->
                        Div(Modifier.classNames("column", "is-flex", "is-justify-content-center").toAttrs()) {
                            Img(
                                src = galleryImg.url,
                                attrs = Modifier
                                    .fillMaxWidth()
                                    .height(300.px)
                                    .objectFit(ObjectFit.Cover)
                                    .cursor(Cursor.Pointer)
                                    .onClick {
                                        truckingGallery.openGallery(scope = scope, galleryImg.photoGalleryIndex!!)
                                    }
                                    .toAttrs())
                        }
                    }
                }

                Div(smallPDFBoxStyle.toModifier()
                        .classNames("box", "is-flex", "is-flex-direction-column", "is-justify-content-center", "mt-6")
                        .toAttrs())
                {
                    H3(Modifier.classNames("title", "has-text-centered", "has-text-dark").toAttrs()) { Text("WANT TO SEE MORE?") }
                    Button(
                        modifier = Modifier.classNames("button", "is-primary"),
                        onClick = {
                            truckingGallery.openGallery(scope = scope, 0)
                        }
                    ) { Text("OPEN GALLERY") }
                }
            }
        }




    }
}